export default __webpack_public_path__ + "static/media/thumbnail.aeed587e.svg";